import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Application } from "../config/const/enums";
import usePreQualification from "../hooks/usePreQualification";
import usePreQualificationPages from "../hooks/usePreQualificationPages";
import useSharedData from "../hooks/useSharedData";
import { PATH_CONTACT_CENTER, PATH_ONLINE } from "../routes/paths";

export default function JWTPageGuard({ children }) {
  try {
    const { pathname } = useLocation();
    const { funcs } = usePreQualificationPages();
    const { dataSet } = usePreQualification();
    const { application } = { ...dataSet };
    const { accessToken } = useSharedData();

    const pageIndex = { ...children }.props.pageIndex;

    const backToQuotePoint = (application) => {
      const currentDomain = window.location.origin;

      switch (application) {
        case Application.ONLINE: {
          window.location.href = `${currentDomain}${PATH_ONLINE.accept}`;
          break;
        }
        case Application.CONTACT_CENTER: {
          window.location.href = `${currentDomain}${PATH_CONTACT_CENTER.openingScript}`;
          break;
        }
      }
    };

    useEffect(() => {
      async function initialize() {
        try {
          if (accessToken == null) {
            // The accessToken is not present in the sharedContext then redirect back to login page
            backToQuotePoint(application);
          }
        } catch (err) {
          console.error("Error occurred while reading the JWT token - ", err);
        }
      }
      initialize();
    }, [pathname, accessToken]);

    // Ensure we are allowed to navigate to the requested page
    const responsePage = funcs.getRequestPage({
      requestPageIndex: pageIndex,
    });
    // Check if this is a navigation 'back'
    if (
      responsePage.allowPageRequest === false ||
      responsePage.isBack === true
    ) {
      return <Navigate to={responsePage.responsePage.previousRoutePath} />;
    }

    // No issue, load the page.
    return <>{children}</>;
  } catch (ex) {
    console.error(ex);
  }
}
